export default __webpack_public_path__ + "static/media/arrow-down.937b1b12.svg";